import httpReq from '@/server/http'

const httpRequest = {

  // **************************基础配置 strat *********************
  getCipherPublicKey: function (params) {
    var url = '/api/v1/common/rsa/public-key';

    return httpReq(url, 'POST', params);
  },
  // type：report_type举报  feedback_type意见反馈类型
  getBasicsReason: function (params) {
    var url = '/api/v1/config/custom-field';

    return httpReq(url, 'GET', params);
  },
  // 分享
  getShareInfo: function (params) {
    var url = '/api/v1/app/public/share';

    return httpReq(url, 'GET', params);
  },
  // 获取cos上传签名
  getCosUploadSign: function (params) {
    var url = '/api/v1/tencent-cloud/token'

    return httpReq(url, 'get', params)
  },
  //  **************************基础配置 en*********************

  // **************************登录注册 start****************
  // 登录
  userLogin: function (params) {
    var url = '/api/v1/auth/token';

    return httpReq(url, 'GET', params);
  },
  // 三方登录
  socialLogin: function (params) {
    var url = '/api/v1/auth/socialite-login';

    return httpReq(url, 'POST', params);
  },
  // 三方绑定
  socialBind: function (params) {
    var url = '/api/v1/auth/socialite-bind';

    return httpReq(url, 'POST', params);
  },
  // 绑定微信qq微博
  thirdBind: function (params) {
    var url = '/api/v1/auth/user/socialite-bind';

    return httpReq(url, 'POST', params);
  },
  // 获取用户信息
  getUserInfo: function () {
    var url = '/api/v1/auth/user';

    return httpReq(url, 'GET');
  },
  // 发送验证码
  sendVerifyCode: function (params) {
    var url = '/api/v1/auth/send-verify-code';

    return httpReq(url, 'post', params);
  },
  // 注册
  userRegister: function (params) {
    var url = '/api/v1/auth/register';

    return httpReq(url, 'post', params);
  },
  // 找回密码
  findPassword: function (params) {
    var url = '/api/v1/auth/find-pwd';

    return httpReq(url, 'post', params);
  },
  // **************************登录注册 end****************


  // **************************首页相关 start****************
  // 获取首页信息(资讯。直播，发现首页轮播)
  getMainPageShowDetail: function (params) {
    var url = '/api/v1/page/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取资讯分类选择列表
  getInformationTextCategoryList: function (params) {
    var url = '/api/v1/payment-information/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取资讯分类列表
  getInformationTextList: function (params) {
    var url = '/api/v1/payment-information/cate/detail';

    return httpReq(url, 'GET', params);
  },
  // 资讯详情
  getInformationDetail: function (params) {
    var url = '/api/v1/payment-information/detail';

    return httpReq(url, 'GET', params);
  },

  // 获取资讯详情评价列表
  getInformationDetailComment: function (params) {
    var url = '/api/v1/payment-information/comment';

    return httpReq(url, 'GET', params);
  },

  // 收藏 (付费资讯 直播）
  collectSource: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'POST', params);
  },

  // 。。。。。。。。。。。。。。 我的 （能用到） 。。。。。。。。。。。。。。。。。
  // 获取我的收藏
  getCollectListByType: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'GET', params);
  },
  // 删除我的收藏（付费资讯 直播）
  cancelCollectResourceByType: function (params) {
    var url = '/api/v1/auth/user/store';

    return httpReq(url, 'DELETE', params);
  },
  // 。。。。。。。。。。。。。。 我的 （能用到）。。。。。。。。。。。。。。。。。

  //提交付费资讯评价（评价回复）
  commentInformation: function (params) {
    var url = '/api/v1/payment-information/comment';

    return httpReq(url, 'POST', params);
  },
  // 举报评价
  reportComment: function (params) {
    var url = '/api/v1/common/report';

    return httpReq(url, 'POST', params);

  },
  // 点赞评价
  commentUserPraise: function (params) {
    var url = '/api/v1/auth/user/praise';

    return httpReq(url, 'POST', params);
  },
  // 取消点赞
  cancelUserPraise: function (params) {
    var url = '/api/v1/auth/user/praise';

    return httpReq(url, 'DELETE', params);

  },
  // 获取热门搜索列表
  getHotSearchList: function (params) {
    var url = '/api/v1/common/search/hot-keywords';

    return httpReq(url, 'GET', params);
  },
  // 获取关键自匹配列表
  getKeyWordMatching: function (params) {
    var url = '/api/v1/common/search/keywords';

    return httpReq(url, 'GET', params);
  },
  // 搜索结果列表
  getSearchResultList: function (params) {
    var url = '/api/v1/common/search';

    return httpReq(url, 'GET', params);
  },
  // **************************首页相关 end****************

  //  **************************直播相关 start****************
  //  获取直播分类选择列表
  getLiveHomeCategoryList: function (params) {
    var url = '/api/v1/live/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取资讯分类列表
  getLiveList: function (params) {
    var url = '/api/v1/live/cate/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取直播详情
  getLiveDetailInfo: function (params) {
    var url = '/api/v1/live/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取聊天室详情
  getChatRoomDetailInfo: function (params) {
    var url = '/api/v1/live/chat-room';

    return httpReq(url, 'GET', params);
  },
  // 获取群成员列表
  getGroupMemberList: function (params) {
    var url = '/api/v1/live/chat-room/member';

    return httpReq(url, 'GET', params);
  },
  // 获取评论历史消息
  getLiveMessageByType: function (params) {
    var url = '/api/v1/live/chat-room/message';

    return httpReq(url, 'GET', params);
  },
  sendGroupChatMessageInfo: function (params) {
    var url = '/api/v1/live/chat-room/message';

    return httpReq(url, 'post', params);
  },
  getMemberDetailById: function (params) {
    var url = '/api/v1/live/chat-room/member/detail';

    return httpReq(url, 'GET', params);
  },
  // 标记直播已试看
  signLiveTryWatch: function (params) {
    var url = '/api/v1/live/audition';

    return httpReq(url, 'post', params);
  },
  uploadMessageImage: function (params) {
    var url = '/api/v1/course/group/message/upload-image';

    return httpReq(url, 'postfile', params);
  },
  // 记录直播用户观看记录
  recordLiveUserWatchStatus: function(params) {
    var url = '/api/v1/user/live';

    return httpReq(url, 'post', params);
  },
  //  **************************直播相关 end****************


  //  **************************发现相关 start****************
  // 获取发现分类选择列表
  getDiscoverCategoryList: function (params) {
    var url = '/api/v1/image-text-apply/cate';

    return httpReq(url, 'GET', params);
  },
  // 获取发现分类列表
  getDiscoverList: function (params) {
    var url = '/api/v1/image-text-apply/cate/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取发现详情
  getDiscoverDetail: function (params) {
    var url = '/api/v1/image-text-apply/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取图文报名验证码接口
  reqimageTextVerifyCode: function (params) {
    var url = '/api/v1/image-text-apply/record/valid';

    return httpReq(url, 'post', params);
  },
  // 图文报名提交
  commitImageTextSignUpInfo: function (params) {
    var url = '/api/v1/image-text-apply/record';

    return httpReq(url, 'post', params);
  },
  // 获取图文报名提交列表列表
  getSubmitTypeList: function (params) {
    var url = 'api/v1/image-text-apply/record/class';

    return httpReq(url, 'GET', params);
  },
  // 上传附件
  uploadFiles: function (params) {
    var url = '/api/v1/image-text-apply/record/user-file';

    return httpReq(url, 'postfile', params.file);
  },
  //上传文件
  uploadFillingFiles(params) {
    var url = '/api/v1/upload/user-image';

    return httpReq(url, 'postfile', params.file);
  },

  //  **************************发现相关 end****************

  // ****************************我的相关 start ***************

  // start-up接口
  getStartupData: function (params) {
    var url = '/api/v1/app/system/start-up';

    return httpReq(url, 'GET', params);
  },

  // 确认订单
  confirmOrder: function (params) {
    var url = '/api/v1/order';

    return httpReq(url, 'post', params);
  },

  // 确认钱包订单充值
  confirmRechargeOrder: function (params) {
    return httpReq("/api/v1/order/wallet-order", "POST", params);
  },
  // 提现配置信息
  getWithDrawDepositConfigInfo: function (params) {
    var url = '/api/v1/wallet/with_draw/config/detail';

    return httpReq(url, 'GET', params);
  },
  // 订单支付
  getPayParametersByPayType: function (params) {
    var url = '/api/v1/order/pay';

    return httpReq(url, 'POST', params);
  },
  //提现
  sureWithdrawDeposit: function (params) {
    var url = '/api/v1/wallet/with_draw';

    return httpReq(url, 'POST', params);
  },
  // 余额支付
  walletPayment: function (params) {
    var url = '/api/v1/wallet/pay';

    return httpReq(url, 'POST', params);
  },
  // 支付结果
  checkPaymentResultStatus: function (params) {
    var url = '/api/v1/pay/result';

    return httpReq(url, 'GET', params);
  },
  // 活动下单
  activityConfirmOrderInfo: function (params) {
    var url = '/api/v1/image-text-apply/order';

    return httpReq(url, 'POST', params);
  },
  // 更新个人信息
  updatePersonalData: function (params) {
    var url = '/api/v1/auth/user/update';

    return httpReq(url, 'POST', params);
  },
  // 更新用户头像
  updateAvatar: function (params) {
    var url = '/api/v1/auth/user/avatar';

    return httpReq(url, 'postfile', params.file);
  },
  // 获取消息列表
  getMessageCenter: function (params) {
    var url = '/api/v1/auth/user/message';

    return httpReq(url, 'GET', params);
  },
  // 获取会员配置列表
  getMemberConfig: function (params) {
    var url = '/api/v1/vip/vip-config';

    return httpReq(url, 'GET', params);
  },
  // 标记已读
  messageTagHasBeenRead: function (params) {
    var url = '/api/v1/auth/user/message/read';

    return httpReq(url, 'POST', params);
  },
  // 删除消息
  delAllMessage: function (params) {
    var url = '/api/v1/auth/user/message';

    return httpReq(url, 'DELETE', params);
  },
  // 获取消息详情
  getMessageDetail: function (params) {
    var url = '/api/v1/auth/user/message/detail';

    return httpReq(url, 'GET', params);
  },

  // 交易记录
  getWalletRecord: function (params) {
    var url = '/api/v1/wallet/record';

    return httpReq(url, 'GET', params);
  },

  // 提交意见反馈
  submitFeedback: function (params) {
    var url = '/api/v1/common/feedback';

    return httpReq(url, 'POST', params);
  },
  // 常见问题列表
  getCommonIssueList: function (params) {
    var url = '/api/v1/content/question';

    return httpReq(url, 'GET', params);
  },
  // 常见问题详情
  getCommonIssueDetail: function (params) {
    var url = '/api/v1/content/question/detail';

    return httpReq(url, 'GET', params);
  },
  // 获取文案详情
  getDocumentDetail: function (params) {
    var url = '/api/v1/common/document';

    return httpReq(url, 'GET', params);
  },

  // 获取报名记录
  getUserRegistrationRecord: function (params) {
    var url = '/api/v1/user/user-apply';

    return httpReq(url, 'GET', params);
  },
  // 获取图文报名详情
  getUserRegistrationRecordDetail: function (params) {
    var url = '/api/v1/image-text-apply/record/detail';

    return httpReq(url, 'GET', params);
  },
  // 取消图文报名
  cancelSignUp: function (params) {
    var url = '/api/v1/image-text-apply/record';

    return httpReq(url, 'DELETE', params);
  },
  // 获取更换手机邮箱验证码
  reqSetVerifyCode: function (params) {
    var url = '/api/v1/auth/user/send-verify-code';

    return httpReq(url, 'POST', params);
  },
  // 绑定第三方账号
  bindThirdAccount: function () {
    var url = 'api/v1/auth/user/socialite-bind';

    return httpReq(url, 'POST', params);
  },
  // 解除第三方绑定账号
  removethirdBind: function (params) {
    var url = '/api/v1/auth/user/socialite-unbind';

    return httpReq(url, 'POST', params);
  },
  // 获取我的已购直播
  getMyboughtLiveList: function (params) {
    var url = '/api/v1/user/live';

    return httpReq(url, 'GET', params);
  },

  // 获取我的已购资讯
  getMyboughtInformationList: function (params) {
    var url = '/api/v1/user/payment-information';

    return httpReq(url, 'GET', params);
  },

  // 获取我的观看记录
  getMyStatisticBrowseList: function (params) {
    var url = '/api/v1/statistic/browse';

    return httpReq(url, 'GET', params);
  },
  // 新增记录
  recordResourceFootprint: function (params) {
    var url = '/api/v1/statistic/browse';

    return httpReq(url, 'POST', params);
  },
  // ****************************我的相关 end ***************

  // *************** 新增 加载更多 功能 start ***************
  // 资讯列表
  getPaymentInformationList: function (params) {
    var url = '/api/v1/payment-information';

    return httpReq(url, 'GET', params);
  },
  // 直播列表
  reqLiveList: function (params) {
    var url = '/api/v1/live';

    return httpReq(url, 'GET', params);
  },
  // 活动列表
  getActivityList: function (params) {
    var url = '/api/v1/image-text-apply';

    return httpReq(url, 'GET', params);
  },
  //更新本人报名信息
  updateSelfSignInfo(params) {
    var url = '/api/v1/auth/user/personal/info';

    return httpReq(url, 'POST', params);
  },
  //活动报名验证码
  getSignActivityCode(params) {
    var url = '/api/v1/information/apply/verify-code';

    return httpReq(url, 'POST', params);
  },
  //活动书体列表
  getActivitySecsesList(params) {
    var url = '/api/v1/filling-work/secs';

    return httpReq(url, 'GET', params);
  },
  // 书体分类列表
  getChirographyStyleList(params) {
    var url = '/api/v1/word-style'

    return httpReq(url, 'get', params)
  },
  // 获取团体会员列表
  getOrganizationMemberList: function(params) {
    var url = '/api/v1/config/custom-field'

    return httpReq(url, 'get', params)
  },
  //活动添加作品
  activityAddWorks(params) {
    var url = '/api/v1/filling-works';

    return httpReq(url, 'POST', params);
  },
  //获取活动作品列表
  getActivitySignList(params) {
    var url = '/api/v1/filling-works';

    return httpReq(url, 'GET', params);
  },
  //活动作品删除
  deleteActivitySignList(params) {
    var url = '/api/v1/filling-works';

    return httpReq(url, 'DELETE', params);
  },
  // 获取活动详情指定用户报名状态
  getActivityCanCurtailData(params) {
    var url = '/api/v1/image-text-apply/can-curtail';

    return httpReq(url, 'GET', params);
  },
  //征稿活动报名
  activitySignWithWorks(params) {
    var url = '/api/v1/filling-work-applies';

    return httpReq(url, 'POST', params);
  },
  //征稿活动报名记录
  fillingWorkRecord(params) {
    var url = '/api/v1/filling-work-applies';

    return httpReq(url, 'GET', params);
  },
  //征稿活动报名记录详情
  fillingWorkRecordDetail(params) {
    var url = '/api/v1/filling-work-applies/detail';

    return httpReq(url, 'GET', params);
  },
  //作品详情
  fillingWorkDetail(params) {
    var url = '/api/v1/filling-works/detail';

    return httpReq(url, 'GET', params);
  },
  //获取作品编辑通道状态
  getWorkEditStatus(params) {
    var url = '/api/v1/filling-works/whether-edit';

    return httpReq(url, 'GET', params);
  },
  //用户重新上传作品附件/视频
  fillingWorkReupload(params) {
    var url = '/api/v1/filling-works/reupload';

    return httpReq(url, 'POST', params);
  },
  //导出报名信息Word
  exportFillingWorkWord(params) {
    var url = '/api/v1/filling-works/export-word';

    return httpReq(url, 'GET', params);
  }

  // *************** 新增 加载更多 功能  end  ***************
}

export default httpRequest



// WEBPACK FOOTER //
// ./src/server/http-api.js